import { render, staticRenderFns } from "./ConflictingUpdateResolutionModal.vue?vue&type=template&id=56b2d124&"
import script from "./ConflictingUpdateResolutionModal.vue?vue&type=script&lang=js&"
export * from "./ConflictingUpdateResolutionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports